import React, { useCallback } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { useNavigate } from '@tanstack/react-router';



const ClientReportTableRow = (props) => {
	const id       = props.row.urpt_id,
		  navigate = useNavigate();

	const handleNavigate = useCallback(() => {
		navigate({ to: `/reports/edit/${id}` });
	}, [ navigate, id ]);


	return (
		<Table.Row
			{...props}
			style={{
				cursor: 'pointer',
			}}
			onClick={handleNavigate}
		/>
	);
};


export default ClientReportTableRow;
